// Module
var code = "<div> <div class=\"single-line\"> <small class=\"single-line\" ng-bind-html=\"entity.title\"></small> <small ng-if=\"entity.title.length==0\"> <i>{{\"ui.no_title\" | transl8}}</i> </small> </div> <div class=\"single-line\"> <small class=\"text-muted\" ng-bind-html=\"entity.subtitle\"> </small> </div> </div> ";
// Exports
module.exports = code;